export function RealTreeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 38.0282C11.6048 38.0282 3.97174 30.386 3.97174 20.9999C3.97174 11.6139 11.6048 3.97168 21 3.97168C30.3952 3.97168 38.0283 11.6139 38.0283 20.9999C38.0283 30.386 30.3861 38.0282 21 38.0282Z"
        fill="url(#paint0_linear_21268_24280)"
      />
      <path
        d="M21 34.3488C28.3774 34.3488 34.3487 28.3683 34.3487 21.0001C34.3487 13.6318 28.3683 7.65137 21 7.65137C13.6317 7.65137 7.65131 13.6318 7.65131 21.0001C7.65131 28.3683 13.6317 34.3488 21 34.3488Z"
        fill="url(#paint1_linear_21268_24280)"
      />
      <path
        opacity="0.62"
        d="M21.0274 26.6973C20.5161 26.6973 20.023 26.5604 19.5939 26.2864C17.8317 25.1908 14.8826 22.8991 14.8643 19.8769C14.8643 18.9091 15.2478 18.0051 15.96 17.3295C16.6539 16.6721 17.5761 16.3069 18.553 16.2978C19.4478 16.2978 20.3243 16.6082 21.0091 17.1378C21.6848 16.5899 22.5522 16.2704 23.4104 16.2612C25.4739 16.2612 27.1357 17.8499 27.1448 19.7947C27.163 22.8078 24.2504 25.1451 22.5065 26.2682C22.0683 26.5512 21.557 26.7064 21.0274 26.7064V26.6973Z"
        fill="url(#paint2_linear_21268_24280)"
      />
      <path
        d="M18.553 17.567C19.4296 17.567 20.2148 17.9962 20.6439 18.5805C20.7626 18.7357 20.9909 19.0736 20.9909 19.0736C20.9909 19.0736 21.2465 18.7357 21.3652 18.5714C21.8126 17.987 22.5978 17.5396 23.4104 17.5305C24.7526 17.5305 25.8483 18.5349 25.8574 19.7949C25.8757 22.2601 23.1639 24.3053 21.8035 25.191C21.3378 25.4923 20.7352 25.5014 20.2604 25.2092C18.8817 24.351 16.1426 22.3423 16.1335 19.877C16.1335 18.617 17.2017 17.5853 18.553 17.5762V17.567Z"
        fill="white"
      />
      <path
        d="M14.0244 11.8422C14.0244 13.4491 12.7278 14.7456 11.13 14.7456C10.5183 14.7456 9.95218 14.5539 9.48653 14.2343C10.4726 12.5635 11.8057 11.1391 13.3852 10.0435C13.7778 10.5365 14.0152 11.1574 14.0152 11.8422H14.0244Z"
        fill="url(#paint3_linear_21268_24280)"
      />
      <path
        d="M23.7574 34.0656C22.8717 34.2573 21.9404 34.3578 21 34.3578C15.4761 34.3578 10.7557 31.016 8.71043 26.2499C10.3083 24.9899 15.5583 25.0813 16.2978 29.4365C18.7265 27.4186 24.5061 28.6239 23.7483 34.0656H23.7574Z"
        fill="url(#paint4_linear_21268_24280)"
      />
      <path
        d="M34.2117 19.1008C30.5322 19.8404 28.0487 17.5851 28.1491 14.9556C23.027 16.1973 20.297 11.2121 22.0409 7.68774C28.3044 8.16253 33.3352 12.956 34.2117 19.0917V19.1008Z"
        fill="url(#paint5_linear_21268_24280)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_21268_24280"
          x1="17.3661"
          y1="47.1678"
          x2="23.8122"
          y2="0.730376"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00E700" />
          <stop offset="0.52" stopColor="#00FF00" stopOpacity="0.89" />
          <stop offset="0.62" stopColor="#19FF00" stopOpacity="0.91" />
          <stop offset="0.82" stopColor="#59FF00" stopOpacity="0.95" />
          <stop offset="1" stopColor="#99FF00" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_21268_24280"
          x1="23.657"
          y1="36.7135"
          x2="18.5713"
          y2="6.62876"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0093AF" />
          <stop offset="0.17" stopColor="#00A388" />
          <stop offset="0.46" stopColor="#00BD4E" />
          <stop offset="0.7" stopColor="#00CF23" />
          <stop offset="0.89" stopColor="#00DA09" />
          <stop offset="1" stopColor="#00DF00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_21268_24280"
          x1="20.3061"
          y1="15.9234"
          x2="22.1778"
          y2="26.533"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1FD00" stopOpacity="0.8" />
          <stop offset="1" stopColor="#00FF6C" stopOpacity="0.3" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_21268_24280"
          x1="15.8413"
          y1="15.9508"
          x2="10.7374"
          y2="11.5135"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#009800" />
          <stop offset="1" stopColor="#009800" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_21268_24280"
          x1="18.0417"
          y1="36.9873"
          x2="13.44"
          y2="17.1652"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00635B" />
          <stop offset="0.03" stopColor="#006558" />
          <stop offset="1" stopColor="#00B700" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_21268_24280"
          x1="39.197"
          y1="24.4695"
          x2="19.813"
          y2="6.0534"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#00635B" />
          <stop offset="0.03" stopColor="#006558" />
          <stop offset="1" stopColor="#00B700" />
        </linearGradient>
      </defs>
    </svg>
  )
}
